import {TextInputEnum} from '../../../utilities/validation/InputValidation';
import { buildUrlAndNavigate } from '../../../utilities/StringHelpers/StringHelpers';

export const productType = {
  Cellular: 'סלולר',
  Energy: 'חשמל',
  LandLine: 'נייח',
};

export const FLOW_STEPS = {
  BENEFITS: 'benefits',
  RECIPIENT: 'recipient',
  ALLOCATION: 'allocation',
};


export const HeaderByStep: {
  [key: string]: {
    title? : string ,
    subtitle? : string ,
    TextfromEpi? : boolean,
  };
} = {
  [FLOW_STEPS.BENEFITS]:{
    title: 'זה הזמן לפרגן למשפחה',
    subtitle: 'בוחרים את ההטבות והכמות הרצויה, ומחליטים לאיזה בן/בת משפחה לשלוח אותן',
    TextfromEpi: true,
  },
  [FLOW_STEPS.RECIPIENT]:{
    title: 'למי לשלוח את ההטבות?',
    subtitle: 'ניתן לחזור על התהליך ולשלוח הטבות לכמה בני משפחה',
  },
  [FLOW_STEPS.ALLOCATION]:{
    title: 'כמה מימושים נשלח לכל הטבה?',
  },
};
export const RECIPIENT_TYPES = {
  SELF: 'self',
  FAMILY: 'family',
};

export const BENEFIT_TABS = {
  ALL: 'all',
  SENT: 'sent',
};


export const messageData = {
  BenefitsSentSuccessfully: {
    icon: require('./icons/success.svg'),
    title:'ההטבה נשלחה בהצלחה!',
    subTitle: 'בן המשפחה שנבחר קיבל הודעות SMS למימוש ההטבה',
    buttonList: [
      {
        text: 'סיום וחזרה להטבות שלי',
        click: 'clearHistory',
        color: 'white',
      },
    ],
    isPopup: true,
    closePopup:  'clearHistory',
  },

  BenefitsSentError: {
    icon: require('./icons/error.svg'),
    title:'משהו השתבש בשליחת ההטבה',
    subTitle: 'נסו לשלוח שוב מאוחר יותר',
    buttonList: [
      {
        text: 'סגירה וחזרה להטבות שלי',
        click: 'goToBenefits',
        color: 'white',
      },
    ],
    isPopup: true,
  },

  BenefitsSentConfirmation: {
    icon: require('./icons/notification.svg'),
    title:'האם לשלוח את ההטבה?',
    subTitle: 'לא נוכל לבצע שינויים לאחר שליחת ההטבה',
    buttonList: [
      {
        text: 'כן, שלח',
        click: 'assignBenefits',
        color: 'primary',
      },
      {
        text: 'לא, חזרה לבחירת ההטבות',
        click: 'goToBenefits',
        color: 'white',
      },
    ],
    isPopup: true,
    closePopup: 'goToBenefits',
  },

  newCustomerPopup: {
    icon: require('./icons/success.svg'),
    title:'נציג יצור איתך קשר להמשך הטיפול',
    subTitle: 'בקשתך להחלפת חבילה נוכחית בוצעה בהצלחה',
    buttonList: [
      {
        text: 'סגירה וחזרה להטבות שלי',
          click: () => {
            goToPersonalArea();
          },
        color: 'white',
      },
    ],
    isPopup: true,
  },
  newCustomerCreateWorkOrderFailed: {
    icon: require('./icons/error.svg'),
    title:'מצטערים משהו השתבש',
    buttonList: [
      {
        text: 'סגירה וחזרה להטבות שלי',
          click: () => {
            goToPersonalArea();
          },
        color: 'white',
      },
    ],
    isPopup: true,
  },
 
  OverBenefits :{
    icon: require('./icons/notification.svg'),
    title:'נראה שההטבה הסתיימה ולא ניתן לממש אותה יותר' ,
    subTitle: 'לפרטים נוספים יש לפנות לעובד {organizationName} ששלח לך את ההטבה',
    buttonList: [
      {
        text: 'סגירה והמשך',
        color: 'white',
      },
    ],

  },

  notificationSentSuccessfully: {
    icon: require('./icons/success.svg'),
    title:'תזכורת למימוש ההטבות נשלחה בהצלחה!',
    subTitle: 'שלחנו הודעת SMS לבן המשפחה שנבחר',
    buttonList: [
      {
        text: 'סיום וחזרה להטבות שלי',
        click: 'goToBenefits',
        color: 'white',
      },
    ],
    isPopup: true,
  },


};

export const recipientFields = [
  {
    label: 'שם פרטי',
    key: 'firstName',
    inputType: TextInputEnum.FirstName,
    required: true,
  },
  {
    label: 'שם משפחה',
    key: 'lastName',
    inputType: TextInputEnum.LastName,
    required: true,
  },
  {
    label: 'מספר טלפון',
    key: 'phoneNumber',
    inputType: TextInputEnum.Phone,
    type: 'tel',
    required: true,
    //checkDuplicate: true,
    //duplicateErrorKey: 'duplicatePhone',
  },
];


export const goToPersonalArea = () => {
  buildUrlAndNavigate(window.Config.orgEmplyeeFamilyUrl);
}


export const getRemainingQuantities = (quantities, members) =>
  Object.keys(quantities || {}).reduce((acc, key) => {
    const used = (members || []).reduce((sum, member) => sum + (Number(member.allocations?.[key]) || 0), 0);
    acc[key] = Math.max(0, quantities[key].quantity - used);
    return acc;
  }, {});

  export const familyMemberTexts = {
    title: 'הטבות לבני משפחות {orgName}',
    secondaryTitle: 'יש לבחור הטבות, בן משפחה שאליו ההטבות ישלחו, ואת כמות ההטבות שתשלח בכל פעם',
    remainingTitle: 'נותרו לחלוקה',
    noRemaining: 'לא נותרו הטבות למימוש',
    remainingToChooseTitle: 'הטבות שנותרו לבחירה',
    addMember: 'הוספת בן משפחה',
    removeMember: 'הסרה',
    remainingLabel: 'נותרו',
    redeemLabel: 'למימוש',
    addProducts: 'הוספת מוצרים',
    editProducts: 'עריכת מוצרים',
    addProductsTitle: 'הוספת מוצרים',
    addProductsSubtitle: 'בחרו כמה מוצרים לשייך לבן המשפחה',
    confirmProducts: 'אישור',
    noProductsAssigned: 'לא שויכו מוצרים',
    continue: 'המשך',
    alreadySent: 'נשלחו',
    chooseBenefits: 'בחרו הטבה והמשיכו',
    saveAndContinue: 'שמירה והמשך',
    back: 'חזרה',
    emptySettings: 'לא נמצאו מכסות זמינות לארגון',
    submitSuccess: 'בני המשפחה נוספו בהצלחה',
    notify: 'שליחת תזכורת',
    notificationSent: 'תזכורת נשלחה',
    cancel: 'ביטול הטבות',
    tabs: {
      all: 'כל ההטבות',
      sent: 'נשלחו',
    },

    recipient: {
      title: 'למי לשלוח את ההטבות?',
      subtitle: 'אפשר לחזור על התהליך ולשלוח הטבות לכמה בני משפחה',
      self: 'לעצמי',
      family: 'לבן משפחה',
    },
    allocation: {
      title: 'כמה מימושים נשלח לכל הטבה?',
      outOfRedeem: 'מתוך {count} למימוש',
      continueAndSend: 'המשך ושליחה',
      existingTitle: 'הטבות קיימות',
      existingQuantity: 'כמות: {count}',
    },
    sentEmpty: 'עדיין לא נשלחו הטבות',
    errors: {
      duplicatePhone: 'מספר הטלפון כבר קיים ברשימה',
      duplicateId: 'תעודת הזהות כבר קיימת ברשימה',
      noAllocation: 'יש לשייך לפחות מוצר אחד',
      submit: 'ארעה שגיאה בשמירת בני המשפחה',
      completeDetails: 'יש להשלים את הפרטים לפני שממשיכים',
    },
  };
